<div class="py-2 px-0">
  <div class="incident-search-wrapper">
    <div>
      <span style="font-weight: 600; font-size: 1.1rem; color: #fff; flex: 1;">
        Users ({{ getNumberOfUsersFilter() }})
      </span>
      <i class="fa fa-bell" style="color: #fff; margin-left: 8px;"></i>
    </div>
    <div style="margin-top: 8px; position: relative;">
      <input class="listSearch form-control" type="text" [(ngModel)]="orgTreeSearch" placeholder="Search User"
        (input)="onSearchInput($any($event.target).value)" style="padding-right: 32px;" autofocus />
        <i class="fa fa-search search-icon-wrapper"></i>
      </div>
    </div>
    <div class="d-flex mb-1 gap-2" style="margin-top: 8px;">
      <select class="form-select customSelect"
        [(ngModel)]="selectedCountry"
        (change)="countryChanged()"
        title="select by country">
        @for (country of countryList; track country) {
          <option [ngValue]="country">{{ country.display }}</option>
        }
      </select>
      <select class="form-select customSelect"
        [(ngModel)]="selectedState"
        (change)="stateChanged()"
        title="select by state">
        @for (state of stateList; track state) {
          <option [ngValue]="state">{{ state.display }}</option>
        }
      </select>
      <select class="form-select customSelect"
        [(ngModel)]="selectedCity"
        (change)="cityChanged()"
        title="select by city">
        @for (city of cityList; track city) {
          <option [ngValue]="city">{{ city.display }}</option>
        }
      </select>
    </div>
    <div class="custom-scroll">
      <cdk-virtual-scroll-viewport itemSize="50" class="custom-scroll">
        <table class="table table-striped table-hover custom-table">
          <tbody>
            <tr *cdkVirtualFor="let user of allUserItemsFiltered; trackBy: trackByUserId">
              <td>{{ user.name }}</td>
              @if (hasShowHomeLocationsPermission()) {
                <td>
                  <i class="fa fa-crosshairs" style="cursor:pointer;"
                    (click)="fetchProfilesFromOrganization(user, $event, false)"
                  title="zoom"></i>
                </td>
              }
              <td>
                <i class="fa fa-info" style="cursor: pointer;"
                  (click)="fetchProfilesFromOrganization(user, $event, true)"
                title="info"></i>
              </td>
              @if (hasVoicePermission()) {
                <td>
                  @if (user.hasMobilePhone) {
                    <i class="fa fa-phone" style="font-size:12px; cursor: pointer"
                    (click)="openPhoneWindow($event, user)" title="phone"></i>
                  }
                  @if (!user.hasMobilePhone) {
                    <i class="fa fa-phone" style="font-size:12px; opacity: 0.25" title="no enabled"></i>
                  }
                </td>
              }
              <td>
                <i class="fa fa-envelope" style="font-size:12px; cursor: pointer"
                (click)="openMultipleMessageModal('Send Message', user, true)" title="send mail"></i>
              </td>
              @if (hasSmsPermission()) {
                <td>
                  @if (user.hasMobilePhone) {
                    <i
                      class="fa fa-commenting"
                      style="font-size:12px; cursor: pointer"
                      (click)="openChatWindow('SMS', user, true)"
                    title="messaging"></i>
                  }
                  @if (!user.hasMobilePhone) {
                    <i
                      class="fa fa-commenting"
                      style="font-size:12px; opacity: 0.25"
                    title="no mobile phone"></i>
                  }
                </td>
              }
            </tr>
          </tbody>
        </table>
      </cdk-virtual-scroll-viewport>
      <ng-container #phoneboxContainer></ng-container>

    </div>
  </div>